import axios from 'axios';
import {
    WorkflowTaskLogRequest,
    WorkflowTaskLog,
} from '../schemas/WorkflowTaskLog.schema';

export function retrieveWorkflowTaskLog(params: WorkflowTaskLogRequest) {
    return axios.get<WorkflowTaskLog>('/v1/log/workflow-task', {
        params,
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('WF_APPLICATION')
        }
    });
}
